module.exports = __webpack_public_path__ + "static/media/download_bold.ad365421.svg";